module.exports = __webpack_public_path__ + "static/media/Visa.82c7b30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/makseKeskus/Visa.png
// module id = 163
// module chunks = 15